import type { FaireProductEntity } from "../../entity_types/product";

export const p_pka8nuv4yx: FaireProductEntity = {
  token: "p_pka8nuv4yx",
  type: "product",
  name: "Atma Buti Wind Chimes - Set of 4",
  brandToken: "b_v58tcqg42w",
  brandName: "Now N Zen",
  imageUrl:
    "https://cdn.faire.com/fastly/de8db5f51d8bcc193269adfc3a8c53d4e63b0dd841da3f8d4bd8b533c12ed315.png",
  galleryImageUrls: [],
  priceDollars: 173.21,
  description:
    "This product is loved by sound healers. Made up of bamboo. Doesn’t include stand! Stand is showing for display purpose only.",
  tags: [],
  msrpDollars: 482.22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:28.818Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
